import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../../Store';
import {
	getAllMedias,
	resetMedias,
} from '../../../Store/AppsManagement/Actions';
import {
	IAppsManagementState,
	Media,
} from '../../../Store/AppsManagement/Types';
import { I18N } from '../../../Store/I18n/Types';
import { IUserState } from '../../../Store/User/Types';
import { UserACL } from '../../../Store/UserManagement/Types';
import { getTheme } from '../../../Themes';
import { isNullOrUndefinedOrEmptyArray } from '../../../Utils/Various';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	appsManagement: IAppsManagementState;
}

interface ISortParams {
	id: 'asc' | 'desc' | undefined;
	name: 'asc' | 'desc' | undefined;
	firstChunk: 'asc' | 'desc' | undefined;
	lastChunk: 'asc' | 'desc' | undefined;
	encoding: 'asc' | 'desc' | undefined;
	mediaSource: 'asc' | 'desc' | undefined;
	type: 'asc' | 'desc' | undefined;
}

interface IState {
	currentID: number;
	openedUser: number;
	page: number;
	resultsPerPage: number;
	params: ISortParams;
	deleteConfirmationOpen: boolean;
	anchorMenu: null | HTMLElement;
	openDialog: boolean;
	userToDelete: UserACL | null;
}

interface IPropsFromDispatch {
	getAllMedias: typeof getAllMedias;
	resetMedias: typeof resetMedias;
}

const theme = getTheme();

const styles = MD.createStyles({
	row: {
		'& > *': {
			borderBottom: 'unset',
		},
	},
	margin: {
		margin: theme.spacing(1),
	},
	noResult: {
		textAlign: 'center',
		fontSize: 'large',
	},
	smallIcon: {
		padding: '3px',
	},
	cell5: {
		width: '5%',
	},
	cell125: {
		width: '12.5%',
	},
	cell15: {
		width: '15%',
	},
	cell20: {
		width: '20%',
	},
	flexContainer: {
		display: 'flex',
		alignItems: 'center',
		boxSizing: 'border-box',
	},
	tableRow: {
		cursor: 'pointer',
	},
	tableRowHover: {
		'&:hover': {
			backgroundColor: theme.palette.grey[200],
		},
	},
	tableCell: {
		flex: 1,
	},
	noClick: {
		cursor: 'initial',
	},
});

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

const initialSorting: ISortParams = {
	id: undefined,
	name: undefined,
	firstChunk: undefined,
	lastChunk: undefined,
	encoding: undefined,
	mediaSource: undefined,
	type: undefined,
};

export class AllChannelComponent extends React.Component<AllProps, IState> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			currentID: 0,
			openedUser: -1,
			page: 0,
			resultsPerPage: 50,
			params: initialSorting,
			deleteConfirmationOpen: false,
			anchorMenu: null,
			openDialog: false,
			userToDelete: null,
		};
	}

	public componentDidMount() {
		if (
			isNullOrUndefinedOrEmptyArray(this.props.appsManagement.allMedias)
		) {
			this.props.getAllMedias();
		}
	}

	componentWillUnmount() { }

	public render(): React.ReactNode {
		const { classes } = this.props;
		return (
			<React.Fragment>
				{this.props.appsManagement.loadingMedias ? (
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
						<MD.CircularProgress />
					</div>
				) : (
					<>
						<MD.TablePagination
							component="div"
							count={this.filterMedias().length}
							rowsPerPage={this.state.resultsPerPage}
							page={this.state.page}
							rowsPerPageOptions={[10, 20, 50, 100]}
							onPageChange={(
								event: React.MouseEvent<HTMLButtonElement> | null,
								page: number
							) => {
								this.setState({
									...this.state,
									page,
								});
							}}
							onRowsPerPageChange={(
								event: React.ChangeEvent<
									HTMLTextAreaElement | HTMLInputElement
								>
							) => {
								const rows = parseInt(event.target.value, 10);

								if (isNaN(rows)) {
									return;
								}
								this.setState({
									...this.state,
									page: 0,
									resultsPerPage: rows,
								});
							}}
						/>
						<MD.TableContainer component={MD.Paper}>
							<MD.Table
								aria-label="collapsible table"
								size="small"
							>
								<MD.TableHead>
									<MD.TableRow id="tablerowuser">
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params.id !==
													undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id:
																this.state
																	.params
																	.id ===
																	undefined ||
																	this.state
																		.params
																		.id ===
																	'desc'
																	? 'asc'
																	: 'desc',
															name: undefined,
															firstChunk:
																undefined,
															lastChunk:
																undefined,
															encoding: undefined,
															mediaSource:
																undefined,
															type: undefined,
														},
													});
												}}
												direction={this.state.params.id}
											>
												ID
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params
														.mediaSource !==
													undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															name: undefined,
															firstChunk:
																undefined,
															lastChunk:
																undefined,
															encoding: undefined,
															mediaSource:
																this.state
																	.params
																	.mediaSource ===
																	undefined ||
																	this.state
																		.params
																		.mediaSource ===
																	'desc'
																	? 'asc'
																	: 'desc',
															type: undefined,
														},
													});
												}}
												direction={
													this.state.params
														.mediaSource
												}
											>
												{this.props.i18n._(
													'Media Source'
												)}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params.name !==
													undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															name:
																this.state
																	.params
																	.name ===
																	undefined ||
																	this.state
																		.params
																		.name ===
																	'desc'
																	? 'asc'
																	: 'desc',
															firstChunk:
																undefined,
															lastChunk:
																undefined,
															encoding: undefined,
															mediaSource:
																undefined,
															type: undefined,
														},
													});
												}}
												direction={
													this.state.params.name
												}
											>
												{this.props.i18n._('Name')}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params
														.firstChunk !==
													undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															name: undefined,
															firstChunk:
																this.state
																	.params
																	.firstChunk ===
																	undefined ||
																	this.state
																		.params
																		.firstChunk ===
																	'desc'
																	? 'asc'
																	: 'desc',
															lastChunk:
																undefined,
															encoding: undefined,
															mediaSource:
																undefined,
															type: undefined,
														},
													});
												}}
												direction={
													this.state.params.firstChunk
												}
											>
												{this.props.i18n._(
													'First Chunk'
												)}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params
														.lastChunk !== undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															name: undefined,
															firstChunk:
																undefined,
															lastChunk:
																this.state
																	.params
																	.lastChunk ===
																	undefined ||
																	this.state
																		.params
																		.lastChunk ===
																	'desc'
																	? 'asc'
																	: 'desc',
															encoding: undefined,
															mediaSource:
																undefined,
															type: undefined,
														},
													});
												}}
												direction={
													this.state.params.lastChunk
												}
											>
												{this.props.i18n._(
													'Last Chunk'
												)}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params
														.encoding !== undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															name: undefined,
															firstChunk:
																undefined,
															lastChunk:
																undefined,
															encoding:
																this.state
																	.params
																	.encoding ===
																	undefined ||
																	this.state
																		.params
																		.encoding ===
																	'desc'
																	? 'asc'
																	: 'desc',
															mediaSource:
																undefined,
															type: undefined,
														},
													});
												}}
												direction={
													this.state.params.encoding
												}
											>
												{this.props.i18n._('Encoding')}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params.type !==
													undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															name: undefined,
															firstChunk:
																undefined,
															lastChunk:
																undefined,
															encoding: undefined,
															mediaSource:
																undefined,
															type:
																this.state
																	.params
																	.type ===
																	undefined ||
																	this.state
																		.params
																		.type ===
																	'desc'
																	? 'asc'
																	: 'desc',
														},
													});
												}}
												direction={
													this.state.params.type
												}
											>
												{this.props.i18n._('Type')}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
										>
											{this.props.i18n._(
												'Fetch users/groups'
											)}
										</MD.TableCell>
									</MD.TableRow>
								</MD.TableHead>
								{this.displayTableBody()}
							</MD.Table>
						</MD.TableContainer>
					</>
				)}
			</React.Fragment>
		);
	}

	private filterMedias(): Media[] {
		let filteredMedias = this.props.appsManagement.allMedias;
		if (this.props.appsManagement.allChannelsFilter === null) {
			return filteredMedias;
		}
		const filter = this.props.appsManagement.allChannelsFilter;

		if (this.props.router.match.params.type === 'mediaarchiver-stt') {
			const allowedid = [
				163859, 170738, 169078, 168239, 76770, 76771, 76772, 76769,
				76762, 76761, 557, 166859, 165038, 555, 548, 37981,
			];
			if (filter.id !== null) {
				const id = filter.id;
				if (filter.isIdContained !== null && filter.isIdContained) {
					filteredMedias = filteredMedias.filter((filteredMedia) =>
						filteredMedia.id.toString().includes(id.toString())
					);
				}
				if (filter.isIdDifferent !== null && filter.isIdDifferent) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) => filteredMedia.id !== id
					);
				}
				if (filter.isIdEqual !== null && filter.isIdEqual) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) => filteredMedia.id === id
					);

					filteredMedias = filteredMedias.filter((filteredMedia) =>
						allowedid.includes(filteredMedia.id)
					);
					return filteredMedias;
				}

				filteredMedias = filteredMedias.filter((filteredMedia) =>
					allowedid.includes(filteredMedia.id)
				);
			}
		} else {
			if (filter.id !== null) {
				const id = filter.id;
				if (filter.isIdContained !== null && filter.isIdContained) {
					filteredMedias = filteredMedias.filter((filteredMedia) =>
						filteredMedia.id.toString().includes(id.toString())
					);
				}
				if (filter.isIdDifferent !== null && filter.isIdDifferent) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) => filteredMedia.id !== id
					);
				}
				if (filter.isIdEqual !== null && filter.isIdEqual) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) => filteredMedia.id === id
					);
					return filteredMedias;
				}
			}
		}

		if (filter.mediaSource !== null) {
			const mediaSource = filter.mediaSource;
			if (
				filter.isMediaSourceContained !== null &&
				filter.isMediaSourceContained
			) {
				filteredMedias = filteredMedias.filter((filteredMedia) =>
					filteredMedia.mediaSource
						.toString()
						.includes(mediaSource.toString())
				);
			}
			if (
				filter.isMediaSourceDifferent !== null &&
				filter.isMediaSourceDifferent
			) {
				filteredMedias = filteredMedias.filter(
					(filteredMedia) => filteredMedia.mediaSource !== mediaSource
				);
			}
			if (
				filter.isMediaSourceEqual !== null &&
				filter.isMediaSourceEqual
			) {
				filteredMedias = filteredMedias.filter(
					(filteredMedia) => filteredMedia.mediaSource === mediaSource
				);
			}
		}

		if (filter.name !== null) {
			const name = filter.name.toLowerCase();
			if (filter.isNameContained !== null && filter.isNameContained) {
				filteredMedias = filteredMedias.filter((filteredMedia) =>
					filteredMedia.name.toLowerCase().includes(name)
				);
			}
			if (filter.isNameDifferent !== null && filter.isNameDifferent) {
				filteredMedias = filteredMedias.filter(
					(filteredMedia) =>
						!filteredMedia.name.toLowerCase().includes(name)
				);
			}
			if (filter.isNameEqual !== null && filter.isNameEqual) {
				filteredMedias = filteredMedias.filter(
					(filteredMedia) => filteredMedia.name.toLowerCase() === name
				);
			}
		}

		if (filter.mediaSourceDuplicate !== null) {
			if (filter.mediaSourceDuplicate) {
				filteredMedias = filteredMedias.filter(
					(filteredMedia) =>
						filteredMedia.id === filteredMedia.mediaSource
				);
			} else {
				let dups = filteredMedias.filter(
					(filteredMedia) =>
						filteredMedia.id !== filteredMedia.mediaSource
				);
				let result = dups.map(({ mediaSource }) => mediaSource);

				filteredMedias = filteredMedias.filter((filteredMedia) =>
					result.includes(filteredMedia.mediaSource)
				);
			}
		}

		if (filter.isencoded !== null && filter.isencoded === true) {
			filteredMedias = filteredMedias.filter(
				(filteredMedia) => filteredMedia.encoding === true
			);
		}

		if (filter.firstChunkCompare !== null) {
			const firstChunk = filter.firstChunkCompare;
			if (
				filter.isFirstChunkBefore !== null &&
				filter.isFirstChunkBefore &&
				filter.isFirstChunkAfter !== null &&
				filter.isFirstChunkAfter
			) {
			} else {
				if (
					filter.isFirstChunkAfter !== null &&
					filter.isFirstChunkAfter
				) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) =>
							filteredMedia.firstChunk >= firstChunk
					);
				}
				if (
					filter.isFirstChunkBefore !== null &&
					filter.isFirstChunkBefore
				) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) =>
							filteredMedia.firstChunk <= firstChunk
					);
				}
			}
		}

		if (filter.lastChunkCompare !== null) {
			const lastChunk = filter.lastChunkCompare;
			if (
				filter.isLastChunkAfter !== null &&
				filter.isLastChunkAfter &&
				filter.isLastChunkBefore !== null &&
				filter.isLastChunkBefore
			) {
			} else {
				if (
					filter.isLastChunkAfter !== null &&
					filter.isLastChunkAfter
				) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) => filteredMedia.lastChunk >= lastChunk
					);
				}
				if (
					filter.isLastChunkBefore !== null &&
					filter.isLastChunkBefore
				) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) => filteredMedia.lastChunk <= lastChunk
					);
				}
			}
		}

		if (filter.type !== null) {
			if (
				filter.isTypeRadio &&
				filter.isTypeTV &&
				filter.isTypeRadio !== null &&
				filter.isTypeTV !== null
			) {
			} else {
				if (filter.isTypeTV && filter.isTypeTV !== null) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) => filteredMedia.type === 2
					);
				}
				if (filter.isTypeRadio && filter.isTypeRadio !== null) {
					filteredMedias = filteredMedias.filter(
						(filteredMedia) => filteredMedia.type === 1
					);
				}
			}
		}

		return filteredMedias;
	}

	private sortMedias(medias: Media[]): Media[] {
		const params = this.state.params;
		if (params.id !== undefined) {
			if (params.id === 'asc') {
				medias = medias.sort((a, b) => (a.id > b.id ? 1 : -1));
			} else {
				medias = medias.sort((a, b) => (a.id < b.id ? 1 : -1));
			}
		}

		if (params.encoding !== undefined) {
			if (params.encoding === 'asc') {
				medias = medias.sort((a, b) =>
					(a.encoding ? 0 : 1) >= (b.encoding ? 0 : 1) ? 1 : -1
				);
			} else {
				medias = medias.sort((a, b) =>
					(a.encoding ? 0 : 1) <= (b.encoding ? 0 : 1) ? 1 : -1
				);
			}
		}

		if (params.firstChunk !== undefined) {
			if (params.firstChunk === 'asc') {
				medias = medias.sort((a, b) =>
					a.firstChunk > b.firstChunk ? 1 : -1
				);
			} else {
				medias = medias.sort((a, b) =>
					a.firstChunk < b.firstChunk ? 1 : -1
				);
			}
		}

		if (params.lastChunk !== undefined) {
			if (params.lastChunk === 'asc') {
				medias = medias.sort((a, b) =>
					a.lastChunk > b.lastChunk ? 1 : -1
				);
			} else {
				medias = medias.sort((a, b) =>
					a.lastChunk < b.lastChunk ? 1 : -1
				);
			}
		}

		if (params.mediaSource !== undefined) {
			if (params.mediaSource === 'asc') {
				medias = medias.sort((a, b) =>
					a.mediaSource > b.mediaSource ? 1 : -1
				);
			} else {
				medias = medias.sort((a, b) =>
					a.mediaSource < b.mediaSource ? 1 : -1
				);
			}
		}
		if (params.type !== undefined) {
			if (params.type === 'asc') {
				medias = medias.sort((a, b) => (a.type > b.type ? 1 : -1));
			} else {
				medias = medias.sort((a, b) => (a.type < b.type ? 1 : -1));
			}
		}
		if (params.name !== undefined) {
			if (params.name === 'asc') {
				medias = medias.sort((a, b) => (a.name > b.name ? 1 : -1));
			} else {
				medias = medias.sort((a, b) => (a.name < b.name ? 1 : -1));
			}
		}

		return medias;
	}

	private displayTableBody(): React.ReactNode | string {
		const classes = this.props.classes;

		let filteredMedias = this.filterMedias();
		filteredMedias = this.sortMedias(filteredMedias);

		if (filteredMedias.length !== 0) {
			return (
				<MD.TableBody>
					{filteredMedias
						.slice(
							this.state.page * this.state.resultsPerPage,
							this.state.page * this.state.resultsPerPage +
							this.state.resultsPerPage
						)
						.map((m, i) => this.generateRow(m, i))}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={7} className={classes.noResult}>
							No result
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}

	private generateRow(media: Media, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell component="th" scope="row">
						{media.id}
					</MD.TableCell>
					<MD.TableCell component="th" scope="row">
						{media.mediaSource}
					</MD.TableCell>
					<MD.TableCell align="left">{media.name}</MD.TableCell>
					<MD.TableCell align="left">
						{media.firstChunk === 0
							? 'No Data'
							: new Date(media.firstChunk).toUTCString()}
					</MD.TableCell>
					<MD.TableCell align="left">
						{media.lastChunk === 0
							? 'No Data'
							: new Date(media.lastChunk).toUTCString()}
					</MD.TableCell>
					<MD.TableCell align="left">
						{media.encoding
							? this.props.i18n._('Currently Encoding')
							: this.props.i18n._('Not Encoding')}
					</MD.TableCell>
					<MD.TableCell align="left">
						{media.type === 2
							? this.props.i18n._('TV')
							: this.props.i18n._('Radio')}
					</MD.TableCell>
					<MD.TableCell align="left">
						<MD.Button
							aria-controls="menu-channel"
							aria-haspopup="true"
							onClick={(
								event: React.MouseEvent<HTMLButtonElement>
							) => {
								this.setState({ currentID: media.id });
								this.openMenuChannel(event);
							}}
						>
							Fetch Users-Groups
						</MD.Button>
						<MD.Menu
							id="menu-channel"
							anchorEl={this.state.anchorMenu}
							keepMounted
							open={Boolean(this.state.anchorMenu)}
							onClose={(
								event: {},
								reason: 'backdropClick' | 'escapeKeyDown'
							) => {
								this.closeMenuChannel();
							}}
						>
							<MD.MenuItem
								onClick={() => {
									this.props.router.history.push(
										`/apps/mediaarchiver/${this.state.currentID}`
									);
								}}
							>
								Mediaarchiver - global
							</MD.MenuItem>

							<MD.MenuItem
								onClick={() => {
									this.props.router.history.push(
										`/apps/mediaarchiver-tpp/${this.state.currentID}`
									);
								}}
							>
								Mediaarchiver - TPP
							</MD.MenuItem>
							<MD.MenuItem
								onClick={() => {
									this.props.router.history.push(
										`/apps/mediaarchiver-stt/${this.state.currentID}`
									);
								}}
							>
								MediaArchiver - STT
							</MD.MenuItem>
							<MD.MenuItem
								onClick={() => {
									this.props.router.history.push(
										`/apps/mytrack/${this.state.currentID}`
									);
								}}
							>
								MyTrack - Global
							</MD.MenuItem>
						</MD.Menu>
					</MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private closeMenuChannel() {
		this.setState({ anchorMenu: null });
	}

	private openMenuChannel(event: React.MouseEvent<HTMLButtonElement>) {
		this.setState({ anchorMenu: event.currentTarget });
	}
}

const mapStateToProps = (
	{ i18n, user, appsManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	appsManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getAllMedias: () => dispatch(getAllMedias()),
	resetMedias: () => dispatch(resetMedias()),
});

export const AllChannels = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(AllChannelComponent));
